// A component that opens the modal when the user is eligible

import React, { useState } from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { useModernizeBanner } from '../hooks/useModernizeBanner.ts';

import { TransactionalModernizeModal } from './TransactionalModernizeModal.tsx';

export const ModernizeBanner = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(() => {
	const { isVisible, onDismiss, error, loading } = useModernizeBanner();

	const [modalVisible, setModalVisible] = useState(false);

	if (error) {
		return <ErrorDisplay error={error} />;
	}

	if (loading || !isVisible) {
		return null;
	}

	return (
		<>
			{modalVisible && (
				<TransactionalModernizeModal
					onClose={() => setModalVisible(false)}
					source="modernize-banner"
					startInVideo
				/>
			)}
			<Banner onClose={onDismiss} onClick={() => setModalVisible(true)} />
		</>
	);
});

const Banner = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-modernize-confluence-banner" */ './Banner/index.ts'))
			.Banner,
});
